/* eslint-disable static-service/require-stories -- we have stories for the Markdown component */
import SimpleMarkdown from "@khanacademy/simple-markdown";

import type {MarkdownRule} from "../types.ts";

export const linebreakRule: Readonly<MarkdownRule> = {
    ...SimpleMarkdown.defaultRules.br,
    match: SimpleMarkdown.anyScopeRegex(/^(?: {2,}\n|<br(?: \/)?>)/),
    react: (node, output, state) => <br key={state.key} />,
};
